import type { ReactNode } from 'react';

import { classFilter } from '@shieldpay/theme-provider-ui/utilities';

import * as styles from './table-row.css';

export interface TableRowProps {
  /**
   * Additional classes to apply.
   */
  className?: string;
  /**
   * Child nodes (e.g. TableDataCell, TableHeaderCell).
   */
  children: ReactNode;
  /**
   * Visually highlight the row.
   */
  highlight?: boolean;
}

export const TableRow = ({
  children,
  className,
  highlight = false,
}: TableRowProps) => (
  <tr
    className={classFilter([
      styles.tableRow,
      highlight && styles.highlight,
      className,
    ])}
  >
    {children}
  </tr>
);
